export default class CacheService {
  /* @ngInject */
  constructor(CacheModel) {
    this.CacheModel = CacheModel;
    this.store = new Map();
  }

  add(result) {
    const url = this.serializedUrl(result.config);
    const newCache = new this.CacheModel(url, result);
    this.store.set(url, newCache);
  }

  get(config) {
    const url = this.serializedUrl(config);
    // const index = this.getIndex(url);
    return this.store.get(url);
  }

  remove(cached) {
    this.store.delete(cached.url);
  }

  isCacheable(config) {
    return config.cacheable !== false;
  }

  // getIndex(url) {
  //   return _findIndex(this.store, cache => cache.url === url);
  // }

  serializedUrl(config) {
    const params = config.paramSerializer(config.params);
    return params ? `${config.url}?${params}` : config.url;
  }

  removeAllExpired() {
    this.store.forEach((cache) => {
      if (cache.isExpired()) {
        this.store.delete(cache.url);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/cache/cache.service.js